import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import styled from 'styled-components';
import ShowMoreLess from '../../../new-components/ShowMoreLess';

interface descriptionProps {
  description: any;
  headtxt?: string;
  directedUrl?: string;
  directedTxt?: string;
  directedUrlClickEvent?: () => void;
}
const Description = ({
  description,
  headtxt,
  directedTxt,
  directedUrl,
  directedUrlClickEvent
}: descriptionProps) => {
  const { t } = useTranslation('entity');

  return (
    <Container id="head">
      <div className="head" itemProp="name">
        {headtxt && (
          <h2 className="headline-3 entity-title">{`${t('about')} ${t(
            headtxt
          )}`}</h2>
        )}
        {directedTxt && directedUrl && (
          <Link
            href={directedUrl}
            prefetch={false}
            onClick={directedUrlClickEvent}
            itemProp="url"
          >
            {t(directedTxt)}
          </Link>
        )}
      </div>
      <div className="description" itemProp="description">
        <ShowMoreLess text={description} />
      </div>
    </Container>
  );
};

const Container = styled.div`
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      font-family: materialRegular;
      font-size: ${props => props.theme.font.sizes.l};
      color: ${props => props.theme.light.colors.primaryOrange};
      text-decoration: underline;
    }
  }

  .description {
    font-family: materialRegular;

    p,
    strong,
    span,
    li,
    div {
      color: ${props => props.theme.light.colors.black} !important;
    }
    p {
      margin-bottom: 4px;
    }

    ul {
      li {
        list-style: disc;
        list-style-position: inside;
      }
    }

    ol {
      li {
        list-style-position: inside;
        position: relative;

        span a {
          position: absolute;
          inset-inline-start: 25px;
        }
      }
    }

    strong {
      font-size: ${props => props.theme.font.sizes.l};
      font-family: materialBold;
    }
  }
`;

export default Description;
